/**
 * Checks whether a correlation has links.
 *
 * @param {Correlation} correlation
 */
export function hasLinks(correlation) {
    return correlation.link.length > 0;
}
//# sourceMappingURL=hasLinks.js.map